
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.4426 17.7815C13.5811 18.617 12.6404 18.4851 11.735 18.0893C10.7768 17.6847 9.89766 17.6671 8.8867 18.0893C7.6208 18.6346 6.95268 18.4763 6.19666 17.7815C1.90667 13.3575 2.53962 6.62036 7.40982 6.3741C8.5966 6.43567 9.42295 7.02494 10.1174 7.07771C11.1548 6.86663 12.1481 6.25976 13.2558 6.33892C14.5832 6.44446 15.5854 6.97217 16.2447 7.92205C13.502 9.56675 14.1525 13.1816 16.6667 14.193C16.1656 15.5123 15.5151 16.8228 14.4338 17.7903L14.4426 17.7815ZM10.0295 6.32133C9.89766 4.36 11.4888 2.74169 13.3173 2.58337C13.5723 4.85253 11.2603 6.54121 10.0295 6.32133Z","fill":"currentColor"}})])
          )
        }
      }
    